import createSharedComposable from '@nicolaudie-group/ng-ui-kit/helpers/createSharedComposable'
import useColorList from '@nicolaudie-group/ng-ui-kit/composables/useColorList'

function useFavoriteColorList() {
  return useColorList({
    key: 'colorpicker-list-favorites',
  })
}

/*
Use a shared reactivity scope, so that changes made by a component to the favorite colors
are tracked between all other components using it within the same browser context
*/
export default createSharedComposable(useFavoriteColorList)
